import { useEffect, useState } from 'react';
import { resolveFirestoreDatabaseId } from 'src/firebase/firestoreDatabase';
import { isFeatureActive } from 'src/helpers/featureFlag';

function readField(field) {
  if (!field || typeof field !== 'object') return undefined;
  if ('booleanValue' in field) return field.booleanValue;
  if ('timestampValue' in field) return field.timestampValue;
  if ('stringValue' in field) return field.stringValue;
  if ('nullValue' in field) return null;
  return undefined;
}

async function fetchPublicFeature(name) {
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  if (!projectId || !apiKey) return null;

  const databaseId = resolveFirestoreDatabaseId();
  const url = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/${encodeURIComponent(databaseId)}/documents/features/${encodeURIComponent(name)}?key=${apiKey}`;
  const response = await fetch(url);
  if (!response.ok) return null;
  const payload = await response.json();
  const fields = payload.fields || {};
  return {
    id: name,
    active: readField(fields.active),
    dateStart: readField(fields.dateStart),
    dateFinal: readField(fields.dateFinal),
  };
}

export function usePublicFeature(name) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchPublicFeature(name)
      .then((feature) => {
        if (!cancelled) setActive(isFeatureActive(feature));
      })
      .catch(() => {
        if (!cancelled) setActive(false);
      });
    return () => {
      cancelled = true;
    };
  }, [name]);

  return { active };
}
